import { getRouteApi } from '@tanstack/react-router';

// By id, not by importing `orgRoute`: the route modules import every page, and
// every page reaches this hook, so importing the route closed an import cycle.
// The id is type-checked against the registered router.
const orgRoute = getRouteApi('/protected/orgs/$orgSlug');

export interface OrgContext {
  /** Canonical 24-char hex ObjectId. Used for every backend call. */
  orgId: string;
  /** URL-facing identifier (lowercase, hyphenated). The address bar value. */
  orgSlug: string;
  /** Display name. */
  orgName: string;
}

/**
 * Active organization context, derived from the URL via TanStack
 * Router's loader chain.
 *
 * The URL is the source of truth (slug). The org route's loader
 * resolves slug → { orgId, orgName } once per route entry, hits /me
 * (cached by TanStack Query inside meRepository), and validates the
 * slug belongs to the user. Descendants read here.
 *
 * Backend boundary uses `orgId` exclusively. UI / address bar use
 * `orgSlug`. The two never diverge.
 *
 * Throws if called outside an org-scoped subtree (caught at runtime,
 * surfaces wrong-component-tree bugs loudly).
 */
export function useOrgContext(): OrgContext {
  return orgRoute.useLoaderData();
}
